/* eslint-disable no-await-in-loop */
import { useState } from 'react';

const useTimeMachine = <T>(value: T) => {
  const [state, setState] = useState<Array<T>>([value]);
  const [current, setCurrent] = useState(0);
  const [isEditable, setIsEditable] = useState(true);

  const updateValues = (newArray: T) => {
    setState((prev) => [newArray, ...prev]);
  };

  const previous = () => {
    if ((current + 1) < state.length) {
      setIsEditable(false);
      setCurrent(current + 1);
    }
  };

  const next = () => {
    if (current > 0) {
      setCurrent(current - 1);
      if ((current - 1) === 0) {
        setIsEditable(true);
      }
    }
  };

  const resume = () => {
    setCurrent(0);
    setIsEditable(true);
  };

  const reset = () => {
    setState([value]);
    setCurrent(0);
    setIsEditable(true);
  };

  const delay = () => new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, 500);
  });

  const replay = async () => {
    setIsEditable(false);
    for (let i = state.length - 1; i >= 0; i -= 1) {
      await delay();
      setCurrent(i);
    }
    setIsEditable(true);
  };

  return {
    state, updateValues, current, previous, next, resume, isEditable, reset, replay,
  };
};

export default useTimeMachine;
